import React from "react";

export const BackArrowIcon = (props) => {
  return (
    <svg
      {...props}
      width="12"
      height="9"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9L1 5M1 5L5 1M1 5H13"
        stroke="#FFD782"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
